/**
 * Footer component for shell layout.
 * Displays copyright information.
 */
export const ShellFooter = () => {
  return (
    <footer className="mt-24 border-t border-default bg-surface">
      <div className="mx-auto max-w-7xl px-6 py-12 md:flex md:items-center md:justify-between lg:px-8">
        <p className="text-center text-sm text-muted w-full">
          &copy; {new Date().getFullYear()} TripVibes. All rights reserved.
        </p>
      </div>
    </footer>
  );
};
